
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';

import { Rt } from './services/Rt.js';
import { createAppRouter } from './router.jsx';

const container = document.getElementById('app');

if (!container) {
	throw new Error('React root element #app not found.');
}

// Global initialization
Rt.csrfToken = document.querySelector('meta[name="csrf-token"]')?.content ?? null;

const router = createAppRouter();

createRoot(container).render(
	<StrictMode>
		<RouterProvider router={router} />
	</StrictMode>
);